import * as React from "react"
import { Typography } from "@mui/material"


export default function countRawColumn() {
	return {
		name: 'countRaw', label: 'Count Raw',
		options: {
			filter: false,
			customBodyRowRender: value => <Typography sx={{ textAlign: 'center' }}>{value}</Typography>
		}
	}
}